import React from 'react';
import { Skeleton } from '../../../../skeleton/Skeleton';

function PrimarySpecialitiesSkeleton({ data }) {
  return (
    <div className="container px-0 container-maxWidth">
      <div className="d-flex flex-column pt-3 pt-sm-4">
        <div className="px-3 px-sm-4 flex-1 d-flex flex-column">
          <div className="flex-1">
            <div className="row row-cols-2 row-cols-sm-3 ms-n3 mt-n3 me-0">
              {data &&
                data?.length > 0 &&
                data.map((key) => (
                  <div className="col ps-3 pt-3 pe-0" key={key.master_specialities_id}>
                    <div className="clr_v3_checkbox position-relative overflow-hidden clr_v3_checkbox__specialityCard">
                      <input
                        type="checkbox"
                        id={`checkbox_${key.master_specialities_id}`}
                        className="clr_v3_checkbox__input position-absolute start-0 top-0 w-100 h-100 z-3 opacity-0"
                      />
                      <label
                        for={`checkbox_${key.master_specialities_id}`}
                        className="clr_v3_checkbox__label position-relative overflow-hidden rounded-3 p-3 border border-105 border-light w-100 h-100"
                      >
                        <div className="overlay z-1 bg-primary"></div>
                        <div className="clr_v3_checkbox__content d-flex flex-column justify-conntent-between">
                          <div className="d-flex align-items-center justify-content-center p-2 clr_v3_checkbox__specialityIcon mb-3 mt:3">
                            <Skeleton variant="rectangular" width={210} height={60} />
                          </div>
                          <span className="flex-1 mt-auto d-flex align-items-center justify-content-center ">
                            {' '}
                            <Skeleton variant="text" width={'50%'} />
                          </span>
                        </div>
                        <div className="clr_v3_checkbox__icon d-flex align-items-center justify-content-center z-2 rounded-circle position-absolute start-50 top-50">
                          <i className="flaticon-check fs-30"></i>
                        </div>
                      </label>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrimarySpecialitiesSkeleton;
